'use strict';

angular.module('chatEngine', [
    'ngResource',
    'ngRoute',
    'ngSanitize',
    'ngAnimate',
    'ngCookies',
    'chatEngine.landing',
    'chatEngine.configuration',
    'chatEngine.directives',
    'chatEngine.filters',
    'chatEngine.services',
    'chatEngine.resources',
    'chatEngine.mixpanel',
    'chatEngine.interceptor',
    'chatEngine.login',
    'chatEngine.verify',
    'chatEngine.tos',
    'chatEngine.reporting',
    'chatEngine.promotion',
    'chatEngine.accountSwitcher',
    'chatEngine.accountSettings',
    'chatEngine.apiKey',
    'chatEngine.engines',
    'chatEngine.docs',
    'chatEngine.contactSettings',
    'chatEngine.dialog',
    'firebase'
])

.run(['$location', function($location) {
    var path = $location.path();
    /*
    There shouldn't be any "#" in $location.path(). An encoded route was visited, and
    the hash failed to be decoded.
    */
    if (path.indexOf('#') !== -1) {
        var pathParts = path.split('#', 2);
        $location.path(pathParts[0]);
        $location.hash(pathParts[1]);
    }
}])

.controller('navbarCtrl', ['$scope', '$location', '$modal', '$http', 'authService', 'mixpanelService', 'Dialog',
    'alertService',
function($scope, $location, $modal, $http, authService, mixpanelService, Dialog, alertService) {
    function isOnTos() {
        return $scope.isActive('^/tos');
    }

    $scope.isActive = function(pattern) {
        var re = new RegExp(pattern);
        return re.test($location.path());
    };

    $scope.showRegularNav = function() {
        return authService.checkAuthCookie() && !isOnTos();
    };

    $scope.showLandingNav = function() {
        return !$scope.showRegularNav() && !isOnTos();
    };

    $scope.alertData = alertService.getAlertData();

    if (authService.checkAuthCookie()) {
        $http.get('/api/v1/contact')
            .error(function() {
                Dialog.alert('Error', 'An error occurred while loading your information.');
            })
            .success(function(response) {
                alertService.setShowAppleIdAlert(!response.apple_developer_id);
            });
    }

    $scope.editContact = function() {
        mixpanelService.forceTrack('Contact Setting Open Alert Click');
        var modal = $modal.open({
            templateUrl: 'views/contact-settings.html',
            controller: 'ContactSettingsCtrl',
            windowClass: 'dialog',
            backdrop: 'static',
            scope: $scope
        });
    };
}])

.config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/reporting', {
        templateUrl: 'views/reporting.html',
        controller: 'ReportingCtrl'
    }).when('/home', {
        templateUrl: 'views/landing.html',
        controller: 'LandingCtrl'
    }).when('/verify/:id', {
        templateUrl: 'views/verify.html',
        controller: 'VerifyCtrl'
    }).when('/promotion', {
        templateUrl: 'views/promotion.html',
        controller: 'PromotionCtrl'
    }).when('/login', {
        templateUrl: 'views/login.html',
        controller: 'LoginCtrl'
    }).when('/tos', {
        templateUrl: 'views/tos-accept.html',
        controller: 'TOSCtrl'
    }).when('/terms', {
        templateUrl: 'views/tos-read.html'
    }).when('/engine/:id', {
        templateUrl: 'views/engine.html',
        controller: 'BaseEngineCtrl'
    }).when('/engines', {
        templateUrl: 'views/engines.html',
        controller: 'EnginesCtrl'
    }).when('/engine', {
        templateUrl: 'views/loading.html',
        controller: 'EngineRedirectCtrl'
    }).when('/docs/:file', {
        templateUrl: 'views/docs.html',
        controller: 'DocsCtrl',
        reloadOnSearch: false
    }).when('/docs', {
        redirectTo: '/docs/getting-started'
    }).otherwise({
        redirectTo: '/reporting'
    });
}])

.config(['$provide', function($provide) {
    $provide.decorator('$exceptionHandler', ['$delegate', function($delegate) {
        return function(exception, cause) {
            $delegate(exception, cause);
            mixpanel.track('ClientException', {
                message: exception.message,
                stackTrace: exception.stack
            });
        };
    }]);
}])

.config(['$compileProvider', function($compileProvider) {
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|file|data):/);
}])

.config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('authInterceptor');
}])

.run(['$window', 'FastClickService', function($window, FastClickService) {
    // Attach fastclick
    FastClickService.attach($window.document.body);
}])

.run(['$rootScope', '$window', '$location', '$modalStack', 'mixpanelService', 'authService', 'sessionDataService',
    'storageService', function($rootScope, $window, $location, $modalStack, mixpanelService, authService,
    sessionDataService, storageService) {

    mixpanelService.init();

    function buildPathFromRoute(routeObj) {
        var path = routeObj.$$route.originalPath;
        for (var property in routeObj.pathParams) {
            if (routeObj.pathParams.hasOwnProperty(property)) {
                var regEx = new RegExp(':' + property, 'gi');
                path = path.replace(regEx, routeObj.pathParams[property].toString());
            }
        }
        return path;
    }

    // saving the last visited route
    $rootScope.$on('$routeChangeStart', function(event, next, current) {
        if(!current) {
            return;
        }

        // Saving the last route the user was in (or trying to access) to redirect to it when logging in
        var route = buildPathFromRoute(next);
        if (route !== '/tos' && route !== '/login' && route !== '/home' && route.indexOf('/verify') !== 0) {
            storageService.setItem('last-route', route);
        }
    });

    // reset sessionDataService if authService doesn't have the cookie anymore
    $rootScope.$on('$routeChangeStart', function() {
        // If you log out on one tab and navigate in another tab, the session data might not be reset, so we need to
        // reset it manually to avoid weird cases.
        if(!authService.checkAuthCookie() && sessionDataService.getKikUsername()) {
            sessionDataService.clear();
            $location.path('/home');
        }
    });

    // allow/forbid access to a route
    $rootScope.$on('$routeChangeStart', function(event, next) {
        var allowNavigation = false;
        var isLoggedIn = authService.checkAuthCookie();
        if (next.redirectTo) {
            allowNavigation = true;
        } else if (!isLoggedIn) {
            // Not logged in, only access to docs and landing
            if(next.originalPath && next.originalPath.indexOf('/docs') === 0) {
                allowNavigation = true;
            } else if(next.originalPath === '/home') {
                allowNavigation = true;
            } else if(next.originalPath === '/login') {
                allowNavigation = true;
            } else if(next.originalPath === '/terms') {
                allowNavigation = true;
            } else if(next.originalPath === '/verify/:id') {
                allowNavigation = true;
            }
        } else {
            // Logged in, access to anything except login
            if(next.originalPath !== '/login') {
                allowNavigation = true;
            }
        }

        if (!allowNavigation) {
            event.preventDefault();

            var redirectTo = isLoggedIn ? '/reporting' : '/home';
            $location.path(redirectTo);
        }
    });

    // automatically track page view on location change
    $rootScope.$on('$routeChangeSuccess', function() {
        mixpanelService.track('Page Viewed', {'page': $location.path()});
    });

    // automatically destroy modal on location change
    $rootScope.$on('$routeChangeSuccess', function() {
        // Closing modals
        var top = $modalStack.getTop();
        if (top) {
            $modalStack.dismiss(top.key);
        }
    });

    // initialize the sessionDataService
    $rootScope.$on('$routeChangeSuccess', function() {
        if ($location.path() !== '/login' && $location.path() !== '/tos' && $location.path() !== '/home' &&
        $location.path().indexOf('/verify') !== 0) {
            if (!sessionDataService.isInitialized()) {
                sessionDataService.init();
            }
        }
    });

    $rootScope.$on('$routeChangeSuccess', function() {
        $rootScope.$broadcast('disable-global-loading');
    });
}])

.run(['sessionDataService', function(sessionDataService) {
    if (!sessionDataService.isInitialized()) {
        sessionDataService.init();
    }
}])

.run(['$rootScope', function($rootScope) {
    $rootScope.globalLoading = false;
    $rootScope.$on('bot-switch-start', function() {
        $rootScope.globalLoading = true;
        $rootScope.globalLoadingMessage = 'Switching accounts...';
    });
    $rootScope.$on('bot-switch-end', function() {
        $rootScope.globalLoading = false;
    });
    $rootScope.$on('disable-global-loading', function() {
        $rootScope.globalLoading = false;
    });
}])

.run(['$rootScope', 'externalLinkService', function($rootScope, externalLinkService) {
    $rootScope.externalLink = externalLinkService.externalLink;
}])

.config(['$anchorScrollProvider', function($anchorScrollProvider) {
    $anchorScrollProvider.disableAutoScrolling();
}]);
